module.exports = __webpack_public_path__ + "static/media/sofa-1.ff03e117.png";